import client from "./client";

export const platformRevenue = async (months = 6) =>
  (await client.get("/platform/revenue", { params: { months } })).data;

export const revenueCsvUrl = () => `${process.env.REACT_APP_BACKEND_URL}/api/platform/revenue/export`;

export const emailStatus = async () => (await client.get("/platform/system/email")).data;

export const emailMetrics = async (days = 14) =>
  (await client.get("/platform/system/email-metrics", { params: { days } })).data;
